module.exports = __webpack_public_path__ + "img/pos-z.33730393.png";